module.exports = __webpack_public_path__ + "02_glasses_black.264c0caf.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer4/02_glasses_black.png
// module id = JJrj
// module chunks = 0